import React, { useEffect, useLayoutEffect, useState } from 'react';
import { EditProfileInfo, EmployeeHeader, Header } from 'widgets';
import { useNavigate, useParams } from 'react-router-dom';
import { UserRoleEnum, userStore } from 'entities/index';
import { Loading } from 'pages/loading/ui/loading.page';
import { BusinessApi } from 'shared/api';
import { PageLayout } from 'shared/ui';

export const EmployeePage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fio, setFio] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [imgUrl, setImgUrl] = useState('');

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof id != 'string') {
      userStore.redirectToRoleBasedPage(navigate);
    } else {
      fetchUserData();
    }
  }, []);

  const fetchUserData = async () => {
    try {
      if (id) {
        const response = await BusinessApi.accountGetInfo({
          accountId: id,
          role: UserRoleEnum.EMPLOYEE,
        });
        setFio(response.fio);
        setPhone(response.phone);
        setEmail(response.email);
        setImgUrl(response.imgUrl);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateData = async (email: string, fio: string, phone: string) => {
    if (id) {
      const response = await BusinessApi.updateEmployeeInfo({
        employeeId: id,
        email,
        fio,
        phone,
      });
      setFio(response.fio);
      setPhone(response.phone);
      setEmail(response.email);
      setImgUrl(response.imgUrl);
    }
  };

  return id ? (
    <PageLayout>
      <Header />
      <EmployeeHeader
        employeeId={id}
        dataEmail={email}
        dataFio={fio}
        dataImgUrl={imgUrl}
        dataPhone={phone}
      />
      <EditProfileInfo
        dataFio={fio}
        dataEmail={email}
        dataPhone={phone}
        updateData={updateData}
      ></EditProfileInfo>
    </PageLayout>
  ) : (
    <Loading />
  );
};
